import { emitMobileTelemetryEvent } from '../mobile/navigation/telemetry';
import { readStoredActiveCall } from './storedCall';
/**
 * `remote_video_stall` records per mounted room: each ladder sends at most
 * two (its outcome, then `resumed`), and the room at most this many.
 */
export const MAX_REMOTE_VIDEO_STALL_EVENTS_PER_ROOM = 16;
/**
 * A reporter for one mounted room stage, web or native.
 *
 * @param {Function} roomName - The room's current name.
 * @returns {Function} Sends one stall outcome, within the room's budget.
 */
export function createRemoteVideoStallReporter(roomName) {
    let events = 0;
    return (stall, extra = {}) => {
        if (events >= MAX_REMOTE_VIDEO_STALL_EVENTS_PER_ROOM) {
            return;
        }
        events += 1;
        const room = roomName();
        const activeCall = readStoredActiveCall();
        const belongsToRoom = Boolean(room && activeCall?.roomName === room);
        emitMobileTelemetryEvent('remote_video_stall', {
            ...stall,
            ...extra
        }, {
            callId: belongsToRoom ? activeCall?.callId : undefined,
            requestId: belongsToRoom ? activeCall?.requestId : undefined,
            roomName: room,
            state: stall.outcome
        });
    };
}
